export default "__VITE_ASSET__CnN38aJv__"